import { render } from "./checkboxs-radios.vue?vue&type=template&id=67b6b0a9"
import script from "./checkboxs-radios.vue?vue&type=script&lang=js"
export * from "./checkboxs-radios.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__